import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../lib/cn';

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  children: ReactNode;
  variant?: 'default' | 'accent' | 'danger';
};

export function Badge({ className, children, variant = 'default', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center border-2 border-brut-border px-2 py-0.5 text-xs font-bold uppercase tracking-wide',
        variant === 'default' && 'bg-brut-bg text-brut-fg',
        variant === 'accent' && 'bg-brut-accent text-white',
        variant === 'danger' && 'bg-brut-danger text-white',
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
